module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/amanda-ferrao-77ba2408d37b102501ef610d0a521e58.jpg";